"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Dialogs_1 = require("./Dialogs");
(function (w, $) {
    if (!$)
        return false;
    var dialogsExtension = {
        confirmDialog: function (options) {
            return this.each(function () {
                var obj = $(this);
                new Dialogs_1.ConfirmDialog(obj, options);
            });
        }
    };
    $.fn.extend(dialogsExtension);
})(window, $);
